export const setCurrentUser = (state, payload) => {
  if (payload == null) {
    state.currentUser = null
  } else {
    state.currentUser = {
      uid: payload.uid,
      displayName: payload.displayName,
      email: payload.email,
      photoURL: payload.photoURL,
      settings: payload.settings,
      rootItems: payload.rootItems,
      username: payload.username
    }
  }
}

export const updateCurrentUser = (state, payload) => {
  if (payload == null) {
    state.currentUser = null
  } else {
    state.currentUser = {
      uid: payload.uid,
      displayName: payload.displayName,
      email: payload.email,
      photoURL: payload.photoURL,
      settings: payload.settings,
      rootItems: payload.rootItems || [],
      username: payload.username,
      sessions: payload.sessions || []
    }
  }
}
